import React, { useEffect, useState } from "react";
import { Tabs, Tab, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AddNewPage from "./AddNewPage/AddNewPage";
import ManageExistingPage from "./ManageExistingPage/ManageExistingPage";
import { TranslatedString } from "@bosch/bt-ui";
import withErrorHandler from "../components/ErrorHandler";
import UserUnrecognizedWarningDialog from "../components/UserUnrecognizedWarningDialog";
import { useAddNewStore } from "../store/add_new_store";

import "./HomePage.css";

const HomePage = (props) => {
  const { token } = props;
  const { company } = useAddNewStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token.authenticated) {
      navigate("/login");
    }
  }, [token.authenticated, navigate]);

  const [openWarning, setWarningOpen] = useState(true)

  if (Array.isArray(company) && company.length == 0) {
    // if no company associated, only show UserUnrecognizedWarningDialog
    return (
      <UserUnrecognizedWarningDialog
        openWarning={openWarning}
        descTranslatedId={['apology-msg', 'user-not-recognized-warning']}
        setWarningOpen={setWarningOpen} />
    )
  }

  return (
    <div id="home-page">
      <h2 className="font-large"></h2>
      {token.token ? (
        <div className="content-wrapper">
          <Container className="mt-3">
            <Tabs
              defaultActiveKey="add-new"
              id="uncontrolled-tab-example"
              className="custom-tabs"
              fill
            >
              <Tab eventKey="add-new" title="Invite New Users" disabled={company == null || Array.isArray(company) && company.length == 0}>
                <AddNewPage />
              </Tab>
              <Tab eventKey="manage-existing" title="Manage Existing Users" disabled={company == null || Array.isArray(company) && company.length == 0}>
                <ManageExistingPage />
              </Tab>
            </Tabs>
          </Container>
        </div>
      ) : (
        <h1 className="font-large">
          <TranslatedString stringId="unauthorized-description" />
        </h1>
      )}
    </div>
  );
};

export default withErrorHandler(React.memo(HomePage));
